// eslint-disable-next-line import/prefer-default-export
export const YusaOvernightCampDashboardSelector = ({
  yusaOvernightCampDashboardData: { YusaOvernightCampAssociationList }
}) => YusaOvernightCampAssociationList;

export const YusaOvernightCampYearSelector = ({
  yusaOvernightCampDashboardData: { YusaOvernightCampYearList }
}) => YusaOvernightCampYearList;
